import type { DeviceId } from "@/components/landing/ResponsiveShowcase/types";
import type { GlyphName } from "@/components/landing/shared";

export const DEVICES: { id: DeviceId; icon: GlyphName }[] = [
	{ id: "desktop", icon: "desktop" },
	{ id: "tablet", icon: "tablet" },
	{ id: "mobile", icon: "phone" },
];

// Shared easing for the coordinated device hand-off and the tab indicator, so
// both movements read as a single gesture. Matches the site's reveal easing.
export const MORPH_EASE = [0.22, 1, 0.36, 1] as const;

// Devices sit in three fixed visual slots (start / center / end). The active
// device always takes the large center slot; the other two shrink into the
// remaining slots in a stable left-to-right order, so switching never makes
// two devices swap past each other.
export function slotFor(id: DeviceId, active: DeviceId): 0 | 1 | 2 {
	if (id === active) return 1;
	const others = DEVICES.map((d) => d.id).filter((d) => d !== active);
	return others[0] === id ? 0 : 2;
}

// How far the two flanking devices sit from centre, keyed to the footprint of
// whichever device currently holds the centre slot. A wider centre device
// pushes its neighbours further out so they still peek at the edges. The value
// is scaled down on small screens via the `--flank-mult` custom property.
export const FLANK_BASE: Record<DeviceId, string> = {
	desktop: "13rem",
	tablet: "8rem",
	mobile: "6.5rem",
};
